import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-radio-button-item',
  templateUrl: './radio-button-item.component.html',
  styleUrls: ['./radio-button-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
    '[class.selected]': 'selected()',
  },
  imports: [CommonModule],
})
export class RadioButtonItemComponent {
  readonly selected = input<boolean>(false);
}
